import { createSelector } from '@ngrx/store';
import { mrraFeatureSelector } from '../reducers/mrra.reducer';

const mrraSelectors = createSelector(
  mrraFeatureSelector,
  (state) => state
);

const getGridFilter = createSelector(
  mrraFeatureSelector,
  (state) => state.gridFilters
);

const getWhatIfRequestData = createSelector(
  mrraFeatureSelector,
  (state) => state.whatIfRequestData
);

const getStatusCounts = createSelector(
  mrraFeatureSelector,
  (state) => state.mrraStatusCounts
);

// Get Account loading **********************************************************
const selectMrraRequestGetAccountLoading = createSelector(
  mrraFeatureSelector,
  (state) => state.loadingGetAccounts
);

const selectMrraRequestGetAccountOverrideLoading = createSelector(
  mrraFeatureSelector,
  (state) => state.loadingGetAccountsOverride
);

export const MrraSelectors = { getGridFilter, getWhatIfRequestData, getStatusCounts, selectMrraRequestGetAccountLoading, selectMrraRequestGetAccountOverrideLoading };
